<template>
    <div class="userSection">
        <h2 v-if="user">{{ user.name }}</h2>

        <div class="container" v-if="loaded">
            <div class="card" @click="goToRoute(1)">
                <p class="card-title">Vocabulary</p>
                <p class="card-content card-content-other">Ver progreso de vocabulario</p>
            </div>
            <div class="card" @click="goToRoute(2)">
                <p class="card-title">Listening</p>
                <p class="card-content card-content-other">Ver progreso de escucha</p>
            </div>
            <div class="card" @click="goToRoute(3)">
                <p class="card-title">Speaking</p>
                <p class="card-content card-content-other">Ver progreso de speaking</p>
            </div>
        </div>

        <div class="container" v-else>
            <img src="../../assets/loading.gif" alt="Loading" style="height: 200px; height: 200px; padding: 10px;">
        </div>

    </div>
</template>

<script>
import router from "@/router";

export default {
    name: "UserSectionSecondView",
    data() {
        return {
            user: {
                name: "",
            },
            loaded: false,
        };
    },
    mounted() {
        this.getUser();
    },
    methods: {
        async getUser() {
            try {
                const response = await this.$axios.get(
                    "users/" +
                    this.$route.params.userId
                );
                //console.log("Respuesta del servidor:", response.data);
                this.user = response.data;
                this.loaded = true;
            } catch (error) {
                //console.error("Error al realizar la solicitud GET:", error);
            }
        },
        goToRoute(route) {
            router.push("/see-specific-user-area/" + this.$route.params.sectionId + "/" + this.$route.params.userId + "/" + route);
        },
    },
};
</script>

<style scoped>
.userSection {
    flex: 1;
    background-color: var(--not-so-grey);
    display: flex;
    align-items: center;
    justify-content: center;
    display: flex;
    flex-direction: column;
}

p {
    margin: 0;
}

.container {
    width: 70%;
    margin: 20px auto;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 20px;
}

.card {
    cursor: pointer;
    background-color: #f4f8f7;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    width: 200px;
    height: 200px;
    padding: 10px;
    gap: 10px;
    border-radius: 10px;
    -webkit-border-radius: 10px;
    -moz-border-radius: 10px;
    -ms-border-radius: 10px;
    -o-border-radius: 10px;
    box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;
    transition: all ease-out 0.5s;
    -webkit-transition: all ease-out 0.5s;
    -moz-transition: all ease-out 0.5s;
    -ms-transition: all ease-out 0.5s;
    -o-transition: all ease-out 0.5s;
}

.card-title {
    font-size: 20px;
    font-weight: bold;
}

.card-content {
    color: var(--another-grey);
    text-align: start;
}

.card-content-other {
    font-style: italic;
}

.card-add {
    align-items: center;
    justify-content: center;
}

.card:hover {
    transform: scale(1.05);
    -webkit-transform: scale(1.05);
    -moz-transform: scale(1.05);
    -ms-transform: scale(1.05);
    -o-transform: scale(1.05);
}
</style>